export const Portuguese = {
  Features: "Recursos",
  Blog: "Blog",
  Trade: "Negociar",
  trade: "negociar",
  Buy: "Comprar/Vender",
  Download: "Baixar",
  The: "O",
  gateway: "portal",
  to: "para",
  To: "Para",
  the: "o",
  next: "próxima",
  generation: "geração",
  of: "de",
  Gamers: "Jogadores",
  Your: "Seus",
  games: "jogos",
  coins: "moedas",
  All: "Tudo",
  in: "em",
  one: "um",
  place: "lugar",
  Simple: "Simples",
  fun: "divertido",
  and: "e",
  And: "E",
  super: "super",
  smart: "inteligente",
  Scan: "Digitalizar",
  download: "baixar",
  app: "aplicativo",
  Available: "Disponível",
  on: "em",
  assets: "ativos",
  Assets: "ativos",
  Game: "Jogo",
  game: "jogo",
  Connect: "Conectar",
  thirdparty: "terceiros",
  Crypto: "Cripto",
  Card: "Cartão",
  Authentication: "Autenticação",
  Own: "Possua",
  your: "seu",
  earn: "ganhe",
  is: "é",
  Is: "É",
  easy: "fácil",
  way: "maneira",
  store: "armazenar",
  manage: "gerenciar",
  winnings: "ganhos",
  Whether: "Seja",
  youre: "você está",
  Youre: "Você está",
  competitive: "competitivo",
  gamer: "jogador",
  or: "ou",
  just: "apenas",
  casual: "casual",
  player: "jogador",
  has: "tem",
  something: "algo",
  for: "para",
  everyone: "todos",
  effortlessly: "facilmente",
  converts: "converte",
  into: "em",
  preferred: "preferido",
  cryptocurrency: "criptomoeda",
  start: "começar",
  earning: "ganhar",
  Exclusive: "Exclusivo",
  content: "conteúdo",
  experiences: "experiências",
  now: "agora",
  at: "em",
  fingertips: "pontas dos dedos",
  passport: "passaporte",
  unlock: "desbloquear",
  favourite: "favorito",
  need: "necessidade",
  do: "fazer",
  connect: "conectar",
  any: "qualquer",
  other: "outro",
  Gaming: "Jogos",
  Platform: "Plataforma",
  account: "conta",
  Once: "Uma vez",
  connected: "conectado",
  youll: "você vai",
  Youll: "Você vai",
  be: "ser",
  able: "capaz",
  rewards: "recompensas",
  unlocking: "desbloqueio",
  instantly: "instantaneamente",
  enjoying: "desfrutando",
  powered: "alimentado",
  by: "por",
  will: "vai",
  launch: "lançar",
  token: "token",
  listing: "listagem",
  major: "importante",
  coming: "chegando",
  soon: "em breve",
  participate: "participar",
  our: "nossa",
  premium: "premium",
  collections: "coleções",
  you: "você",
  You: "Você",
  must: "deve",
  signup: "inscrever-se",
  get: "obter",
  verified: "verificado",
  buy: "comprar",
  using: "usando",
  respectively: "respectivamente",
  Smartest: "Mais inteligente",
  Safe: "Seguro",
  Secure: "Seguro",
  Earn: "Ganhar",
  Big: "Grande",
  Join: "Junte-se",
  Trend: "Tendência",
  Dont: "Não",
  left: "esquerda",
  behind: "atrás",
  Welcome: "Bem-vindo",
  world: "mundo",
  possibilities: "possibilidades",
  space: "espaço",
  no: "não",
  longer: "mais",
  thing: "coisa",
  it: "isso",
  present: "presente",
  Over: "Acima",
  invested: "investido",
  projects: "projetos",
  past: "passado",
  year: "ano",
  free: "gratuito",
  easiest: "mais fácil",
  anywhere: "em qualquer lugar",
  anytime: "a qualquer momento",
  Use: "Usar",
  accepted: "aceito",
  from: "de",
  online: "online",
  globally: "globalmente",
  With: "Com",
  an: "um",
  instant: "instantâneo",
  cash: "dinheiro",
  conversions: "conversões",
  can: "pode",
  spend: "gastar",
  without: "sem",
  hassles: "dificuldades",
  top: "topo",
  notch: "categoria",
  security: "segurança",
  blockchain: "blockchain",
  backbone: "espinha dorsal",
  are: "são",
  always: "sempre",
  safe: "seguro",
  perfect: "perfeito",
  most: "mais",
  out: "fora",
  Rewarding: "Recompensador",
  complete: "completo",
  control: "controle",
  over: "sobre",
  funds: "fundos",
  while: "enquanto",
  prioritizing: "priorizando",
  gaming: "jogos",
  back: "retorno",
  with: "com",
  every: "cada",
  use: "uso",
  today: "hoje",
  level: "nível",
  up: "aumentar",
  rules: "regras",
  only: "apenas",
  keys: "chaves",
  so: "então",
  Our: "Nossa",
  audited: "auditado",
  audit: "auditoria",
  firms: "empresas",
  constantly: "constantemente",
  reviewed: "analisado",
  ensure: "assegurar",
  maximum: "máximo",
  Convenience: "Conveniência",
  moment: "momento",
  WAYS: "FORMAS",
  AUTHENTICATION: "AUTENTICAÇÃO",
  TO: "PARA",
  STRENGTHEN: "FORTALECER",
  YOUR: "SEUS",
  ASSETS: "ATIVOS",
  SAFETY: "SEGURANÇA",
  enjoy: "desfrutar",
  all: "todos",
  this: "isso",
  amazing: "incrível",
  functionalities: "funcionalidades",
  A: "Um",
  Decentralized: "Descentralizado",
  wallet: "carteira",
  dedicated: "dedicado",
  Home: "Início",
  Marketplace: "Mercado",
  Privacy: "Privacidade",
  Policy: "Política",
  Terms: "Termos",
  Service: "Serviço",
  Navigation: "Navegação",
  Products: "Produtos",
  Legal: "Legal",
  What: "O que",
  How: "Como",
  blockchains: "blockchain",
  does: "faz",
  support: "apoiar",
  types: "tipos",
  deposit: "depósito",
  withdraw: "retirar",
  earned: "ganho",
  my: "meu",
  I: "EU",
};
